import { supabase } from '../supabaseClient.js';

export const createZoomMeeting = async (topic, startTime, duration) => {
  try {
    const { data, error } = await supabase.functions.invoke('create-zoom-meeting', {
      body: { topic, startTime, duration },
    });

    if (error) throw error;

    if (!data || !data.id || !data.join_url) {
      throw new Error('Invalid response from Zoom API');
    }

    console.log('Zoom meeting created:', data);
    return data;
  } catch (error) {
    console.error('Error creating Zoom meeting:', error);
    throw error;
  }
};